// export const doDownload = (url) => {
//   const link = document.createElement("iframe");
//   link.src = url;
//   link.style.display = "none";
//   document.body.appendChild(link);
//   link.click();
//   setTimeout(() => {
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   }, 60 * 1000);
// };


export const downloadFiles = (urls: string[]) => {
  urls.map(value => doDownload(value));
};


export const doDownload = (url:string) => {
  const link = document.createElement("iframe");
  link.src = url;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, 60 * 1000);
};

const pickFileName = (url: string, fallback = "file.pdf") => {
  try {
    const u = new URL(url, window.location.origin);
    const last = u.pathname.split("/").filter(Boolean).pop();
    if (last) return decodeURIComponent(last);
  } catch {}
  return fallback;
};

export const openInNewTab = (url: string) => {
  window.open(url, "_blank", "noopener,noreferrer");
};
/**
 * 下载PDF文件,如强制下载失败，则打开新标签页展示pdf内容。
 */
export const doDownloadPDF = async (url: string, fileName?: string) => {
  const name = fileName || pickFileName(url);
  try {
    const resp = await fetch(url, { credentials: "omit" });
    if (!resp.ok) {
      openInNewTab(url);
      return;
    }
    const blob = await resp.blob();
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = objectUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(objectUrl);
    }, 60 * 1000);
  } catch {
    openInNewTab(url);
  }
};

// export const doDownloadPDF = (url) => {
//   const FileSave = require('file-save');
//   const oReq = new XMLHttpRequest();
//   const URLToPDF = url;
//   oReq.open("GET", URLToPDF, true);
//   oReq.responseType = "blob";
//   oReq.onload = function() {
//       const file = new Blob([oReq.response], {
//           type: 'application/pdf'
//       });
//       FileSave.saveAs(file, "");
//   };

//   oReq.send();
// }

